import i18n from './configs/language'

const bankData = {
  // India-印度
  countryNo_91: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: false,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankIFSCCode'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.bankIFSCCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty||indiaBankbranch',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 11,
      minlength: 11
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 17,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.email'),
      name: 'email',
      type: 'text',
      placeholder: i18n.t('bankData.emailPlaceholder'),
      maxLength: 100,
      required: true,
      valid: 'isNonEmpty||isEmail',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Colombia 哥伦比亚
  countryNo_42: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.nationalId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.nationalIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 13
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        { text: 'NIT', value: 'NIT' },
        { text: 'CC', value: 'CC' },
        { text: 'CE', value: 'CE' },
        { text: 'PASS', value: 'PASS' }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 18,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.email'),
      name: 'email',
      type: 'text',
      placeholder: i18n.t('bankData.emailPlaceholder'),
      maxLength: 100,
      required: true,
      valid: 'isNonEmpty||isEmail',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // Brazil-巴西
  countryNo_29: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.individualTaxId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.individualTaxIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 19
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankBranch'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.bankBranchPlaceholder'),
      maxLength: 50,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 14,
      minLength: 8,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Chile 智利
  countryNo_41: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.individualTaxId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.individualTaxIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 10
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [{ text: 'RUT', value: 'RUT' }],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 45,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' },
        { text: 'Vista account', value: 'V' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Morocco 摩洛哥
  countryNo_136: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.ribOfBankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 24,
      minLength: 24,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Egypt 埃及
  countryNo_58: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.ibanPlaceholder'),
      maxLength: 29,
      required: true,
      valid: 'isNonEmpty||EgyptBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // Turkey 土耳其
  countryNo_205: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: false,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 26,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Pakistan 巴基斯坦
  countryNo_152: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 24,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 20
    }
  ],
  // Malaysia 马来西亚
  countryNo_121: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 12,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // Portugal 葡萄牙
  countryNo_161: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 26,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // Spain 西班牙
  countryNo_188: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 26,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // Singapore 新加坡
  countryNo_180: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 26,
      required: true,
      valid: 'isNonEmpty||TurkeyBankaccount',
      errorInfo: 'empty_or_incorrect_format'
    }
  ],
  // Philippines-菲律宾
  countryNo_159: [
    {
      show_name: i18n.t('bankData.name'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty||thirdPartName',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 16,
      minLength: 10
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty||PhilippinesPhone',
      errorInfo: 'empty_or_incorrect_format'
    },
    // 新增
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // Indonesia 印度尼西亚
  countryNo_92: [
    {
      show_name: i18n.t('bankData.name'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty||thirdPartName',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 35
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  Epay: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        { text: 'Foreign Passport', value: 'Foreign Passport' },
        { text: 'Australian', value: 'Australian' },
        { text: 'Passport', value: 'Passport' },
        { text: 'Driver Licese', value: 'Driver Licese' },
        { text: 'National ID', value: 'National ID' }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 20
    },
    {
      show_name: i18n.t('bankData.documentCountry'),
      name: 'documentCountry',
      type: 'selectList',
      placeholder: i18n.t('bankData.documentCountryPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.issueDate'),
      name: 'documentIssueDate',
      type: 'selectDate',
      placeholder: i18n.t('bankData.issueDatePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.expireDate'),
      name: 'documentExpireDate',
      type: 'selectDate',
      placeholder: i18n.t('bankData.expireDatePlaceholder'),
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankBranchName'),
      name: 'bankBranchName',
      type: 'text',
      placeholder: i18n.t('bankData.bankBranchNamePlaceholder')
    },
    {
      show_name: i18n.t('bankData.bankBranch'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.branchPlaceholder')
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 45,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.gender'),
      name: 'gender',
      type: 'select',
      selectArr: [
        { text: i18n.t('common.male'), value: 'Male' },
        { text: i18n.t('common.female'), value: 'Female' }
      ],
      placeholder: i18n.t('bankData.genderPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.email'),
      name: 'email',
      type: 'text',
      placeholder: i18n.t('bankData.emailPlaceholder'),
      maxLength: 100,
      required: true,
      valid: 'isNonEmpty||isEmail',
      errorInfo: 'empty_or_incorrect_format'
    },
    {
      show_name: i18n.t('bankData.birthday'),
      name: 'birthday',
      type: 'selectDate',
      placeholder: i18n.t('bankData.birthdayPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phone'),
      name: 'phone',
      type: 'PhoneEpay',
      placeholder: i18n.t('bankData.phoneNumber'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    // 新增 20210319
    {
      show_name: i18n.t('bankData.bankAddress'),
      name: 'bankAddress',
      type: 'text',
      placeholder: i18n.t('bankData.bankAddressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccountName'),
      name: 'bankAccountName',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 20210318新增
  // 澳大利亚 13
  countryNo_13: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.province'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.provincePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.postalCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postalCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 45,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // South Korea-韩国
  countryNo_186: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // United States - 美国
  countryNo_213: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.savingsAccount'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankBranch'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.abaRoutingNumber'),
      maxLength: 100,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.province'),
      name: 'province',
      type: 'select',
      selectArr: [
        {
          text: 'Alabama',
          value: 'Alabama'
        },
        {
          text: 'Alaska',
          value: 'Alaska'
        },
        {
          text: 'Arizona',
          value: 'Arizona'
        },
        {
          text: 'Arkansas',
          value: 'Arkansas'
        },
        {
          text: 'California',
          value: 'California'
        },
        {
          text: 'Colorado',
          value: 'Colorado'
        },
        {
          text: 'Connecticut',
          value: 'Connecticut'
        },
        {
          text: 'Delaware',
          value: 'Delaware'
        },
        {
          text: 'Florida',
          value: 'Florida'
        },
        {
          text: 'Georgia',
          value: 'Georgia'
        },
        {
          text: 'Hawaii',
          value: 'Hawaii'
        },
        {
          text: 'Idaho',
          value: 'Idaho'
        },
        {
          text: 'Illinois',
          value: 'Illinois'
        },
        {
          text: 'Indiana',
          value: 'Indiana'
        },
        {
          text: 'Iowa',
          value: 'Iowa'
        },
        {
          text: 'Kansas',
          value: 'Kansas'
        },
        {
          text: 'Kentucky',
          value: 'Kentucky'
        },
        {
          text: 'Louisiana',
          value: 'Louisiana'
        },
        {
          text: 'Maine',
          value: 'Maine'
        },
        {
          text: 'Maryland',
          value: 'Maryland'
        },
        {
          text: 'Massachusetts',
          value: 'Massachusetts'
        },
        {
          text: 'Michigan',
          value: 'Michigan'
        },
        {
          text: 'Minnesota',
          value: 'Minnesota'
        },
        {
          text: 'Mississippi',
          value: 'Mississippi'
        },
        {
          text: 'Missouri',
          value: 'Missouri'
        },
        {
          text: 'Montana',
          value: 'Montana'
        },
        {
          text: 'Nebraska',
          value: 'Nebraska'
        },
        {
          text: 'Nevada',
          value: 'Nevada'
        },
        {
          text: 'New Hampshire',
          value: 'New Hampshire'
        },
        {
          text: 'New Jersey',
          value: 'New Jersey'
        },
        {
          text: 'New Mexico',
          value: 'New Mexico'
        },
        {
          text: 'New York',
          value: 'New York'
        },
        {
          text: 'North Carolina',
          value: 'North Carolina'
        },
        {
          text: 'North Dakota',
          value: 'North Dakota'
        },
        {
          text: 'Ohio',
          value: 'Ohio'
        },
        {
          text: 'Oklahoma',
          value: 'Oklahoma'
        },
        {
          text: 'Oregon',
          value: 'Oregon'
        },
        {
          text: 'Pennsylvania',
          value: 'Pennsylvania'
        },
        {
          text: 'Rhode Island',
          value: 'Rhode Island'
        },
        {
          text: 'South Carolina',
          value: 'South Carolina'
        },
        {
          text: 'South Dakota',
          value: 'South Dakota'
        },
        {
          text: 'Tennessee',
          value: 'Tennessee'
        },
        {
          text: 'Texas',
          value: 'Texas'
        },
        {
          text: 'Utah',
          value: 'Utah'
        },
        {
          text: 'Vermont',
          value: 'Vermont'
        },
        {
          text: 'Virginia',
          value: 'Virginia'
        },
        {
          text: 'Washington',
          value: 'Washington'
        },
        {
          text: 'West Virginia',
          value: 'West Virginia'
        },
        {
          text: 'Wisconsin',
          value: 'Wisconsin'
        },
        {
          text: 'Wyoming',
          value: 'Wyoming'
        }
      ],
      placeholder: i18n.t('bankData.provincePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postalCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postalCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // United Kingdom - 英国
  countryNo_212: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.englandBankAccount'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankBranch'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.bankBranchPlaceholder'),
      maxLength: 50,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 阿根廷
  countryNo_10: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.individualTaxId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.individualTaxIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 11,
      minlength: 11
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: 'CBU/CVU',
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 22,
      minlength: 22
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 厄瓜多尔
  countryNo_57: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        { text: 'CI', value: 'CI', isHandleDoId: true, mimLen: 10, maxLen: 10 },
        {
          text: 'RUC',
          value: 'RUC',
          isHandleDoId: true,
          mimLen: 13,
          maxLen: 13
        },
        {
          text: 'PASS-Passport',
          value: 'PASS',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 12
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 12,
      minlength: 8
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 30
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 墨西哥
  countryNo_129: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 18
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        { text: 'RFC', value: 'RFC' },
        { text: 'CURP', value: 'CURP' }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'DEBIT', value: 'DEBIT' },
        { text: 'CLABE', value: 'CLABE' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 巴拉圭
  countryNo_157: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        { text: 'CI', value: 'CI', isHandleDoId: true, mimLen: 7, maxLen: 7 },
        { text: 'RUC', value: 'RUC', isHandleDoId: true, mimLen: 8, maxLen: 8 }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.nationalId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.nationalIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 8,
      minlength: 7
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 16,
      minlength: 16
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 尼日利亚
  countryNo_147: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 16
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 乌拉圭
  countryNo_214: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      isDefault: 1,
      selectArr: [
        { text: 'CI', value: 'CI', isHandleDoId: true, mimLen: 8, maxLen: 8 },
        {
          text: 'RUT',
          value: 'RUT',
          isHandleDoId: true,
          mimLen: 12,
          maxLen: 12
        },
        {
          text: 'DE(Documento Extranjero)',
          value: 'DE',
          mimLen: 0,
          maxLen: 20
        },
        { text: 'PASS(Passport)', value: 'PASS', mimLen: 0, maxLen: 20 }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      minLength: 8,
      maxLength: 8
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankBranch2'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.bankBranch2Placeholder')
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'for Checking accounts', value: 'C' },
        { text: 'for Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      required: true
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 14,
      minLength: 7
    }
  ],
  // 俄罗斯
  countryNo_166: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.paternalName'),
      name: 'beneficiaryPaternalName',
      type: 'text',
      placeholder: i18n.t('bankData.paternalNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.passportIdNumber'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 50
    }
  ],
  // 孟加拉国
  countryNo_18: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      minLength: 8,
      maxLength: 18
    },
    {
      show_name: i18n.t('bankData.bankBranch'),
      name: 'bankBranch',
      type: 'text',
      placeholder: i18n.t('bankData.bankBranchPlaceholder'),
      maxLength: 9,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 德国
  countryNo_74: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccount'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 阿尔及利亚
  countryNo_4: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccount'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 多米尼加
  countryNo_56: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        {
          text: 'Registro Nacional Contribuyente',
          value: 'RN',
          isHandleDoId: true,
          mimLen: 10,
          maxLen: 10
        },
        {
          text: 'Cédula',
          value: 'CE',
          isHandleDoId: true,
          mimLen: 13,
          maxLen: 13
        },
        {
          text: 'Pasaporte',
          value: 'PASS',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 12
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty||onlyInt',
      errorInfo: 'empty_or_incorrect_format',
      maxLength: 12,
      minlength: 8
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 30
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 沙特阿拉伯
  countryNo_175: [
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 24
    }
  ],
  // 哥斯达黎加
  countryNo_47: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 22
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        {
          text: 'cédula de identidad',
          value: 'CI',
          isHandleDoId: true,
          mimLen: 9,
          maxLen: 9
        },
        {
          text: 'cédula jurídica',
          value: 'CJ',
          isHandleDoId: true,
          mimLen: 10,
          maxLen: 10
        },
        {
          text: 'cédula de residencia',
          value: 'CR',
          isHandleDoId: true,
          mimLen: 11,
          maxLen: 22
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 22
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 玻利维亚
  countryNo_26: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.nationalId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.nationalIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 15
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        {
          text: 'Cédula de identidad',
          value: 'CI',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 8
        },
        {
          text: 'Cédula de Identidad de extranjero',
          value: 'CE',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 9
        },
        {
          text: 'Número de Identificación Tributaria',
          value: 'NIT',
          isHandleDoId: true,
          mimLen: 5,
          maxLen: 15
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 15,
      minLength: 10
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 巴拿马
  countryNo_155: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 50
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 45
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 秘鲁
  countryNo_158: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.nationalId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.nationalIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 11
    },
    {
      show_name: i18n.t('bankData.bankCode'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: false
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 20
    },
    {
      show_name: i18n.t('bankData.accountType'),
      name: 'accountType',
      type: 'select',
      selectArr: [
        { text: 'Checking accounts', value: 'C' },
        { text: 'Savings accounts', value: 'S' },
        { text: 'Maestra accounts', value: 'M' }
      ],
      placeholder: i18n.t('bankData.accountTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 坦桑尼亚
  countryNo_198: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        {
          text: 'Passport',
          value: 'PASS',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 9
        },
        {
          text: 'National Id ',
          value: 'NI',
          isHandleDoId: true,
          mimLen: 11,
          maxLen: 11
        },
        {
          text: 'Military',
          value: 'MIL',
          isHandleDoId: true,
          mimLen: 4,
          maxLen: 20
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'PhoneWallet',
      prefix: '+255',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 9,
      tips: 'Available Mobile Money Brands: Airtel, Tigo, m-pesa, Vodafone, Zantel, Halopesa, Ezy-pesa, TTCL',
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 乌干达
  countryNo_209: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentId'),
      name: 'documentId',
      type: 'text',
      placeholder: i18n.t('bankData.documentIdPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.documentType'),
      name: 'documentType',
      type: 'select',
      selectArr: [
        {
          text: 'Passport',
          value: 'PASS',
          isHandleDoId: true,
          mimLen: 8,
          maxLen: 9
        },
        {
          text: 'National Id ',
          value: 'NI',
          isHandleDoId: true,
          mimLen: 11,
          maxLen: 11
        },
        {
          text: 'Military',
          value: 'MIL',
          isHandleDoId: true,
          mimLen: 4,
          maxLen: 20
        }
      ],
      placeholder: i18n.t('bankData.documentTypePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'PhoneWallet',
      prefix: '+256',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 9,
      tips: 'Available Mobile Money Brands: Africell, M-cash, Payway, Eezy Money, MTN, Airtel, Uganda Telecom',
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 阿联酋
  countryNo_211: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // OTT新增189-14
  // 斯里兰卡
  countryNo_189: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 肯尼亚
  countryNo_104: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 柬埔寨
  countryNo_34: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 意大利
  countryNo_97: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 荷兰
  countryNo_142: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 拉脱维亚
  countryNo_109: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 希腊
  countryNo_77: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 法国
  countryNo_68: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 芬兰
  countryNo_67: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 塞浦路斯
  countryNo_51: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 捷克共和国
  countryNo_52: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 比利时
  countryNo_21: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 奥地利
  countryNo_14: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 23,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.phoneNumber'),
      name: 'phone',
      type: 'text',
      placeholder: i18n.t('bankData.phoneNumberPlaceholder'),
      maxLength: 20,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankSwift',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    }
  ],
  // 新增银行卡提现20230512
  // 克罗地亚
  countryNo_48: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 丹麦
  countryNo_54: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 匈牙利
  countryNo_89: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 挪威
  countryNo_150: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 波兰
  countryNo_160: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 瑞典
  countryNo_193: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankName',
      type: 'text',
      placeholder: i18n.t('bankData.bankNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 40
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 30,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankSwift'),
      name: 'bankCode',
      type: 'text',
      placeholder: i18n.t('bankData.bankSwiftPlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ],
  // 泰国
  countryNo_199: [
    {
      show_name: i18n.t('bankData.beneficiaryName'),
      name: 'beneficiaryName',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryNamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.beneficiaryLastname'),
      name: 'beneficiaryLastname',
      type: 'text',
      placeholder: i18n.t('bankData.beneficiaryLastnamePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    },
    {
      show_name: i18n.t('bankData.bankName'),
      name: 'bankCode',
      type: 'selectList',
      placeholder: i18n.t('bankData.bankNamePlaceholder2'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.bankAccount'),
      name: 'bankAccount',
      type: 'text',
      placeholder: i18n.t('bankData.bankAccountPlaceholder'),
      maxLength: 45,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.address'),
      name: 'address',
      type: 'text',
      placeholder: i18n.t('bankData.addressPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.city'),
      name: 'city',
      type: 'text',
      placeholder: i18n.t('bankData.cityPlaceholder'),
      maxLength: 200,
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.state'),
      name: 'province',
      type: 'text',
      placeholder: i18n.t('bankData.statePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip'
    },
    {
      show_name: i18n.t('bankData.postCode'),
      name: 'postalCode',
      type: 'text',
      placeholder: i18n.t('bankData.postCodePlaceholder'),
      required: true,
      valid: 'isNonEmpty',
      errorInfo: 'empty_tip',
      maxLength: 100
    }
  ]
}

export default bankData



// WEBPACK FOOTER //
// ./src/bankdata.js